const isAxateEnabled = (domain: string) => {
  const axateDomains = ['yorkshirepost.co.uk', 'newsletter.co.uk']

  return axateDomains.includes(domain)
}

export default isAxateEnabled
